export const CONTRACT_POINT_BASE_NUMBER = 1.0001;
